// @flow
import { media } from '~/core/utils/style';
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

export const UpperContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;

    ${media.tablet`
        flex-direction: row;
    `};
`;

export const CloseButtonContainer = styled.div`
    cursor: pointer;
    display: flex;
    flex: 0 0 3em;
    justify-content: center;
`;

export const CloseButton = styled(SVGIcon)`
    height: 2em;
    width: 2em;
`;

export const Title = styled.div`
    align-items: center;
    display: flex;
    font-size: 1.2em;
    height: 4em;
    justify-content: center;

    ${media.tablet`
        flex: 1 0 10em;
        justify-content:flex-start;
        padding-left: 1em;
    `};
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;

    & > a {
        white-space: nowrap;
    }

    ${media.tablet`
        flex: 0 0 5em;
        justify-content:flex-end;
    `};
`;

const Line = styled.hr`
    border-top-color: ${p => p.theme.secondaryMedium};
    margin: 0;
`;

export const MobileLine = styled(Line)`
    position: absolute;
    top: 50%;
    width: 120%;

    ${media.tablet`
        display: none;
    `};
`;

export const NonMobileLine = styled(Line)`
    display: none;

    ${media.tablet`
        display: inherit;
    `};
`;

export const LowerContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 2em;

    ${media.tablet`
        flex-direction: row;
    `};
`;

export const Description = styled.div`
    line-height: 1.5em;
    padding: 0 0 2em;

    ${media.tablet`
        flex: 2 0 10em;
        padding-right: 4em;
    `};
`;

export const DevicesColumn = styled.div`
    ${media.tablet`
        flex: 1 0 10em;
    `};
`;

export const ThisActionUses = styled.div`
    font-size: 0.9em;
    margin-bottom: 1em;
`;

export const ListContainer = styled.ul`margin: 0;`;

export const ModalTitle = styled.div`
    color: ${p => p.theme.mainBrandColor};
    height: 3em;

    & > span {
        font-size: 1.2em;
    }
`;

export const ModalContent = styled.div`
    padding: 0.5em 0 1em;

    & > span {
        font-size: 1.1em;
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/template-description/styles.js